import { render } from "./PatriciaRibeiro.vue?vue&type=template&id=ec0ed4e2&scoped=true"
import script from "./PatriciaRibeiro.vue?vue&type=script&lang=js"
export * from "./PatriciaRibeiro.vue?vue&type=script&lang=js"

import "./PatriciaRibeiro.vue?vue&type=style&index=0&id=ec0ed4e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec0ed4e2"]])

export default __exports__